<template>
  <worker-contract-data-form
    v-if="shouldShowForm"
    @on-save-success="onSaveSuccess"
    @on-is-form-valid="onIsFormValid"
    @update-contract-data="updateContractData" />
  <worker-contract-data-view v-else />
</template>

<script>
import { isUserAccountant } from 'packages/common';
import WorkerContractDataForm from './WorkerContractDataForm';
import WorkerContractDataView from './WorkerContractDataView';
import { isStatusPending } from '../../../../../../services/approvalService';
import store from '../../../../../../store/index';

export default {
  name: 'WorkerContractDataTab',
  components: {
    WorkerContractDataForm,
    WorkerContractDataView,
  },
  props: {
    isEditMode: Boolean,
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    isContractPending() {
      return isStatusPending(this.workerBasicInfo?.contractData);
    },
    shouldShowForm() {
      return this.isEditMode || !!(isUserAccountant() && this.isContractPending);
    },
  },
  watch: {
    shouldShowForm: {
      immediate: true,
      handler(value) {
        this.$emit('toggle-edit-mode', value);
      },
    },
  },
  methods: {
    onSaveSuccess() {
      this.$emit('on-save-success');
    },
    onIsFormValid(value) {
      this.$emit('on-is-form-valid', value);
    },
    updateContractData(contractData) {
      this.$emit('update:contract-data', contractData);
    },
  },
};
</script>
